import Button from '@modules/common/components/button';

const ButtonSkeleton = () => (
  <div className="bg-grey-20 ml-auto h-10 w-24 animate-pulse rounded-sm" />
);

interface SettlementNotificationButtonProps {
  hasExistingPayment: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export const SettlementNotificationButton = ({
  hasExistingPayment,
  isLoading,
  onClick,
}: SettlementNotificationButtonProps) => {
  if (isLoading) {
    return <ButtonSkeleton />;
  }

  return (
    <Button
      variant={hasExistingPayment ? 'outlined' : 'primary'}
      onClick={onClick}
      className="ml-auto"
      data-testid="settlement-notification-button"
    >
      {hasExistingPayment ? '本月已有繳款' : '繳款通知'}
    </Button>
  );
};
